import { FormEvent } from "react";
import { Search } from "react-feather";

// A busca grande (página inicial e telas de aviso): campo largo com o botão
// "Rastrear" dentro.
export default function BuscaGrande({ onBuscar, valor, autoFocus = false }: { onBuscar: (codigo: string) => void; valor?: string; autoFocus?: boolean }) {
  const buscar = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const codigo = String(new FormData(e.currentTarget).get("trackingCode") ?? "").trim();
    if (codigo) onBuscar(codigo);
  };

  return (
    <form onSubmit={buscar} role="search" className="w-full max-w-xl">
      <label htmlFor="trackingCode" className="sr-only">
        Código de rastreio
      </label>
      <div className="flex h-16 items-center rounded-2xl bg-white pl-4 sm:pl-5 shadow-[0_8px_30px_rgba(63,32,33,0.12)] ring-1 ring-[#E2D6CB] focus-within:ring-2 focus-within:ring-[#DC4405]">
        <Search size={20} className="shrink-0 text-[#8a7778]" />
        <input
          key={valor}
          size={1}
          id="trackingCode"
          name="trackingCode"
          required
          defaultValue={valor}
          autoFocus={autoFocus}
          autoComplete="off"
          autoCapitalize="characters"
          spellCheck={false}
          placeholder="Código de rastreio"
          className="min-w-0 flex-1 bg-transparent px-2.5 text-base text-[#3F2021] sm:px-3 sm:text-lg outline-none placeholder:text-[#A8978F]"
        />
        <button type="submit" className="mr-2 h-12 shrink-0 rounded-xl bg-[#DC4405] px-4 text-base font-bold text-white transition hover:bg-[#C2410C] sm:px-7">
          Rastrear
        </button>
      </div>
    </form>
  );
}
